import { api } from "./api";

const KEY = "ez_te_cache_v1";
let cache = {};
try { cache = JSON.parse(localStorage.getItem(KEY) || "{}"); } catch { cache = {}; }
const lastSet = new WeakMap();
const waiting = new Map();
let timer = null;
const SKIP = "script,style,noscript,code,textarea,input,select,[translate=no],.notranslate";
const ATTRS = ["placeholder", "title", "aria-label"];

const want = (s) => s.length > 1 && s.length < 400 && /[A-Za-z]{2,}/.test(s) && !/^https?:\/\//.test(s) && !/^[\w.+-]+@[\w-]+\.[\w.]+$/.test(s);
const skip = (el) => !el || !!el.closest?.(SKIP);

const save = () => {
  const keys = Object.keys(cache);
  if (keys.length > 4000) keys.slice(0, keys.length - 4000).forEach((k) => delete cache[k]);
  try { localStorage.setItem(KEY, JSON.stringify(cache)); } catch { /* storage full */ }
};

const queue = (key, fn) => {
  if (!waiting.has(key)) waiting.set(key, new Set());
  waiting.get(key).add(fn);
  clearTimeout(timer);
  timer = setTimeout(flush, 250);
};

async function flush() {
  while (waiting.size) {
    const keys = [...waiting.keys()].slice(0, 80);
    const jobs = keys.map((k) => [k, waiting.get(k)]);
    keys.forEach((k) => waiting.delete(k));
    api.post("/translate", { texts: keys, lang: "te" }).then(({ data }) => {
      Object.assign(cache, data);
      save();
      jobs.forEach(([k, fns]) => cache[k] && fns.forEach((fn) => fn(cache[k])));
    }).catch(() => {});
  }
}

function textNode(n) {
  const v = n.nodeValue;
  if (lastSet.get(n) === v || skip(n.parentElement)) return;
  const key = v.trim();
  if (!want(key)) return;
  const put = (tr) => { if (n.nodeValue === v) { n.nodeValue = v.replace(key, tr); lastSet.set(n, n.nodeValue); } };
  if (cache[key]) put(cache[key]); else queue(key, put);
}

function attrs(el) {
  if (!el.getAttribute || el.closest("[translate=no],.notranslate")) return;
  ATTRS.forEach((a) => {
    const v = el.getAttribute?.(a);
    if (!v || el.dataset[`te${a.replace("-", "")}`] === v) return;
    const key = v.trim();
    if (!want(key)) return;
    const put = (tr) => { if (el.getAttribute(a) === v) { el.setAttribute(a, tr); el.dataset[`te${a.replace("-", "")}`] = tr; } };
    if (cache[key]) put(cache[key]); else queue(key, put);
  });
}

function walk(root) {
  if (root.nodeType === 3) return textNode(root);
  if (root.nodeType !== 1) return;
  [root, ...root.querySelectorAll("[placeholder],[title],[aria-label]")].forEach(attrs);
  if (skip(root)) return;
  const w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  for (let n = w.nextNode(); n; n = w.nextNode()) textNode(n);
}

export function startAutoTranslate() {
  document.documentElement.lang = "te";
  document.head.appendChild(Object.assign(document.createElement("link"), { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Noto+Sans+Telugu:wght@400;600;800&display=swap" }));
  walk(document.body);
  new MutationObserver((muts) => muts.forEach((m) => {
    if (m.type === "characterData") textNode(m.target);
    else if (m.type === "attributes") attrs(m.target);
    else m.addedNodes.forEach(walk);
  })).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ATTRS });
}
